export const prepareEntityToSendById = (objectToSend,entityName) =>{
    let entityObject =  objectToSend[entityName]
    objectToSend[entityName] = (entityObject?objectToSend[entityName]["@id"]:"")
}
